import client from "./client.js";

export const fetchServices = () =>
  client.get("/services").then((r) => r.data.data);

export const fetchService = (id) =>
  client.get(`/services/${id}`).then((r) => r.data.data);

export const createService = (payload) =>
  client.post("/services", payload).then((r) => r.data.data);

export const updateService = (id, payload) =>
  client.patch(`/services/${id}`, payload).then((r) => r.data.data);

export const deleteService = (id) => client.delete(`/services/${id}`);
